/**
 * Storefront-side analytics helpers, shared across the storefront
 * (`pages/Storefront.jsx`), the focused sell page (`pages/SellPage.jsx`),
 * and the checkout modal (`components/commerce/StorefrontBuyModal.jsx`).
 *
 * Extracted from `pages/Storefront.jsx` during the v142.3 refactor so
 * the buy modal + sell page could move into their own modules without
 * dragging the whole storefront page along for the ride.
 */
import { API } from "../../lib/api";

// Stable per-browser visitor id so we can dedupe unique views without
// stashing PII. Persisted to localStorage so a returning buyer counts as
// one visitor across sessions.
export function getVisitorId() {
  if (typeof window === "undefined") return null;
  try {
    let v = window.localStorage.getItem("storefront_vid");
    if (!v) {
      v = `sv_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
      window.localStorage.setItem("storefront_vid", v);
    }
    return v;
  } catch { return null; }
}

// Fire-and-forget POST to `/public/storefront/{slug}/track`. Silent on
// failure — analytics is best-effort.
export function trackStorefront(slug, event, product_id) {
  if (!slug || !event) return;
  try {
    fetch(`${API}/public/storefront/${encodeURIComponent(slug)}/track`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, product_id, visitor_id: getVisitorId() }),
    }).catch(() => {});
  } catch { /* ignore */ }
}
